import api from '@/lib/api';

export type PaginatedMeta = {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
};

export type ResourceArticle = {
  id: string;
  title: string;
  slug: string;
  excerpt?: string | null;
  content?: string | null;
  cover_image?: string | null;
  read_time?: string | null;
  category?: string | null;
  tags?: string[] | null;
  author_name?: string | null;
  is_featured: boolean;
  published_at?: string | null;
  seo_title?: string | null;
  seo_description?: string | null;
  views_count: number;
};

export type ResourceVideo = {
  id: string;
  title: string;
  slug: string;
  description?: string | null;
  thumbnail?: string | null;
  video_url?: string | null;
  duration?: string | null;
  difficulty_level?: string | null;
  category?: string | null;
  is_featured: boolean;
  published_at?: string | null;
  views_count: number;
};

export type ResourceSuccessStory = {
  id: string;
  organization_name: string;
  title: string;
  slug: string;
  challenge?: string | null;
  solution?: string | null;
  result?: string | null;
  attendees_count: number;
  events_supported: number;
  city?: string | null;
  cover_image?: string | null;
  is_featured: boolean;
  published_at?: string | null;
};

export type ResourceFaq = {
  id: string;
  question: string;
  answer: string;
  category?: string | null;
  sort_order: number;
};

export type PlatformGuideContent = {
  id?: string;
  audience: string;
  page_title: string;
  page_subtitle?: string | null;
  steps: { title: string; description: string }[];
  is_published?: boolean;
  updated_at?: string | null;
};

type PaginatedResponse<T> = {
  success: boolean;
  data: T[];
  meta: PaginatedMeta;
};

export const resourceHubApi = {
  articles: (params?: { page?: number; per_page?: number; q?: string; category?: string }) =>
    api.get<PaginatedResponse<ResourceArticle>>('/v1/resources/articles', { params }),
  articleBySlug: (slug: string) =>
    api.get<{ success: boolean; data: ResourceArticle }>(`/v1/resources/articles/${slug}`),
  videos: (params?: { page?: number; per_page?: number; q?: string; category?: string }) =>
    api.get<PaginatedResponse<ResourceVideo>>('/v1/resources/videos', { params }),
  videoBySlug: (slug: string) =>
    api.get<{ success: boolean; data: ResourceVideo }>(`/v1/resources/videos/${slug}`),
  successStories: (params?: { page?: number; per_page?: number; q?: string }) =>
    api.get<PaginatedResponse<ResourceSuccessStory>>('/v1/resources/success-stories', { params }),
  successStoryBySlug: (slug: string) =>
    api.get<{ success: boolean; data: ResourceSuccessStory }>(`/v1/resources/success-stories/${slug}`),
  faqs: () => api.get<{ success: boolean; data: ResourceFaq[]; meta: { total: number } }>('/v1/resources/faqs'),
  platformGuide: (audience: string) =>
    api.get<{ success: boolean; data: PlatformGuideContent }>(`/v1/resources/platform-guides/${audience}`),
  submitQuestion: (payload: { question: string; name?: string; email?: string }) =>
    api.post('/v1/resources/questions', payload),
};

